export const messages = {
  en: {
    addPrivilege: {
      addPrivilege: 'Add Privilege',
      inputPrivilegeName: 'Enter privilege name',
      search: 'Search',
      privilegeCode: 'Privilege Code',
      privilegeName: 'Privilege Name',
      createTime: 'Create Time',
      submit: 'Submit',
      cancel: 'Cancel',
      addSuccess: 'Privilege added successfully'
    },
    deletePrivilege: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete',
      cancel: 'Cancel',
      deleteSuccess: 'Privilege deleted successfully'
    }
  },
  zh: {
    addPrivilege: {
      addPrivilege: '添加权限',
      inputPrivilegeName: '输入权限名称',
      search: '查询',
      privilegeCode: '权限编码',
      privilegeName: '权限名称',
      createTime: '创建时间',
      submit: '提交',
      cancel: '取消',
      addSuccess: '权限添加成功'
    },
    deletePrivilege: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确认删除',
      cancel: '取消',
      deleteSuccess: '权限删除成功'
    }
  }
}